import { closeIconV2 } from '@/shared/ui/assets';
import { CustomButton } from '@/shared/ui/components';
import { Drawer } from 'antd';
import { ReactSVG } from 'react-svg';
import { t } from 'ttag';
import './editPatientDetails.scss';
import { gettextEditPatientDetailsTitle } from '@/shared/lib';
import type { EditPatientDetailProps } from './editPatientDetails.types';

/**
 * Wraps one of the patient detail editing forms in a 500px right-side drawer. Visibility follows the truthiness of the open key, the heading text is resolved from that key through the localized title helper, and a close button in the title row invokes the supplied close handler.
 *
 * @param isOpenModal - Key of the patient section being edited; falsy keeps the drawer closed.
 * @param content - Form rendered inside the drawer body.
 * @param handleClose - Callback invoked by the close button.
 * @returns The patient details editing drawer.
 */
const EditPatientDetail = ({ isOpenModal, content, handleClose }: EditPatientDetailProps) => {
  const closeButton = (
    <CustomButton
      id="close-btn"
      style="neutral"
      type="tertiary"
      size="small"
      icon={<ReactSVG src={closeIconV2} />}
      onClick={handleClose}
      ariaLabel={t`Close`}
    />
  );

  return (
    <Drawer
      open={!!isOpenModal}
      aria-label={gettextEditPatientDetailsTitle(isOpenModal)}
      closable={false}
      width={500}
      rootClassName="custom-drawer edit-study-detail-drawer"
    >
      <div className="drawer-title-container">
        <span className="drawer-title">{gettextEditPatientDetailsTitle(isOpenModal)}</span>
        {closeButton}
      </div>
      <div className="drawer-body-container">{content}</div>
    </Drawer>
  );
};

export default EditPatientDetail;
